module.exports = __webpack_public_path__ + "static/img/miyu.76368ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/miyu.png
// module id = MfIk
// module chunks = 24